import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import SearchResultGrid from "../searchResultGrid/searchResultGrid";
import Permissions from "../../interfaces/permissions";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import permissionsColumnDef from "../../colDef/permissionsColDef";
import apiClient from "../../axiosClient";
import HandlePermissionsModal from "../modals/handlePermissionsModal";

const modalModes = { create: 'create', edit: 'edit' };

const ManagePermissions: React.FC = () => {
    const [permissions, setPermissions] = useState<Permissions[]>([]);
    const [selectedPermissions, setSelectedPermissions] = useState<Permissions[]>([]);
    const [addPermissionModalOpen, setAddPermissionModalOpen] = useState<boolean>(false);
    const [modalMode, setModalMode] = useState<string>(modalModes.create);
    const [loading, setLoading] = useState<boolean>(false);

    const openModal = (mode: string) => {
        setModalMode(mode);
        setAddPermissionModalOpen(true);
    };

    const fetchPermissions = async () => {
        try {
            setLoading(true);
            const response = await apiClient.get('/api/v1/permissions');
            if (response.status === 200) {
                setPermissions(response.data);
            }
        } catch (error: any) {
            if (error.response) {
                alert('Error response data:' + error.response.data.message);
            } else if (error.request) {
                alert('No response received:' + error.request);
            } else {
                alert('Error message:' + error.message);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPermissions();
    }, []);

    const handleSelectedRows = (ids: GridRowSelectionModel) => {
        setSelectedPermissions(permissions.filter(val => ids.ids.has(val.permission_name)));
    };

    return (
        <Box m={2} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 2 }}>
                {selectedPermissions.length === 1 ? (
                    <Button sx={{ mr: 2 }} variant="outlined" onClick={() => openModal(modalModes.edit)}>
                        <Typography>Edit Permission</Typography>
                    </Button>
                ) : null}
                <Button variant="outlined" onClick={() => openModal(modalModes.create)}>
                    <Typography>Add Permission</Typography>
                </Button>
            </Box>
            {loading ? (
                <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress color="primary" />
                </Box>
            ) : (
                <SearchResultGrid
                    columns={permissionsColumnDef}
                    results={permissions}
                    rowCount={permissions.length}
                    onSelectRow={handleSelectedRows}
                    getRowId={(row: Permissions) => row.permission_name}
                />
            )}
            <HandlePermissionsModal
                open={addPermissionModalOpen}
                onClose={() => setAddPermissionModalOpen(false)}
                selectedPermission={selectedPermissions.length > 0 ? selectedPermissions[0] : undefined}
                modalMode={modalMode}
                getAPIFunction={fetchPermissions}
            />
        </Box>
    );
};

export default ManagePermissions;